<template>
	<div :class="`flex flex-col gap-1 ${relative ? '' : 'overflow-y-auto absolute z-40 max-h-96 shadow-md mt-1 p-2 border rounded dark:shadow-black bg-gray-50 dark:bg-gray-950 border-gray-200 dark:border-gray-800'}`">
		<slot/>
	</div>
</template>
<script setup lang="ts">
import {defineProps} from 'vue'

defineProps<{
	relative?:boolean,
}>()
</script>
